import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import './index.scss';
import env from 'libs/env';

interface Props {
    onRetry?: () => void;
    message: string;
    showRetry?: boolean;
    style?: React.CSSProperties;
    type?: string;
}

const isInDouyin = env.isInAweme || env.isInToutiao;

const EmbeddedFailure: FunctionComponent<Props> = (props) => {
    const { showRetry = true, type = 'time-fail', style } = props;
    return (
        <div className="failure--embedded" onClick={props.onRetry}>
            <img
                style={style}
                src={require(`./imgs/${type}.png`)}
                className="failure--embedded__img"
            />
            <div className="failure--embedded__words">{props.message}</div>
            {showRetry ? (
                <div className={cx('failure--embedded__btn', { douyin: isInDouyin })}>点击重试</div>
            ) : null}
        </div>
    );
};

export default EmbeddedFailure;
